webpackJsonp([87192162464282],{

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Link = function Link(_ref) {
	    var children = _ref.children,
	        to = _ref.to,
	        other = _objectWithoutProperties(_ref, ['children', 'to']);
	
	    var internal = /^\/(?!\/)/.test(to);
	
	    if (internal) {
	        return _react2.default.createElement(
	            _gatsbyLink2.default,
	            _extends({ to: to }, other),
	            children
	        );
	    }
	    return _react2.default.createElement(
	        'a',
	        _extends({ href: to }, other),
	        children
	    );
	};
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJss = __webpack_require__(13);
	
	var _reactJss2 = _interopRequireDefault(_reactJss);
	
	var _BackgroundImageSection = __webpack_require__(57);
	
	var _BackgroundImageSection2 = _interopRequireDefault(_BackgroundImageSection);
	
	var _Section = __webpack_require__(58);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Link = __webpack_require__(21);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	    container: {
	        '& li': {
	            listStyle: 'none'
	        }
	    },
	    sectionIndices: {
	        '& > ul > li': {
	            margin: '1.88rem 0',
	            fontFamily: ['Noto Sans Bold', 'sans-serif'],
	            fontSize: '2.1rem'
	        },
	        '& > ul > ul > li': {
	            margin: '1.88rem 0',
	            fontFamily: ['Noto Sans Medium', 'sans-serif'],
	            fontSize: '1.4rem',
	            textTransform: 'capitalize'
	        },
	        '& > ul > ul > ul > li': {
	            margin: '1.5rem 0'
	        },
	        '& > ul > ul > ul > li > a': {
	            color: '#0096C4',
	            textDecoration: 'none'
	        }
	    },
	    sectionAnswers: {
	        '& > ul > li': {
	            margin: '7.5rem 0 3.5rem 0',
	            fontFamily: ['Noto Sans Bold', 'sans-serif'],
	            fontSize: '2.1rem',
	            textTransform: 'capitalize'
	        },
	        '& > ul > ul > li': {
	            margin: '3.5rem 0'
	        },
	        '& > ul > ul > li li': {
	            margin: '0.5rem 0',
	            listStyle: 'circle'
	        },
	        '& > ul > ul em': {
	            fontStyle: 'normal',
	            textDecoration: 'underline'
	        }
	    },
	    answer: {
	        paddingLeft: '1.25rem'
	    },
	    anchor: {
	        display: 'block',
	        position: 'relative',
	        top: -84,
	        visibility: 'hidden'
	    }
	};
	
	exports.default = (0, _reactJss2.default)(styles)(function (_ref) {
	    var classes = _ref.classes,
	        data = _ref.data;
	
	    var categories = ['general', 'troubleshooting'];
	
	    var indices = categories.map(function (category, index) {
	        return [_react2.default.createElement(
	            'li',
	            { key: 'category' },
	            category
	        ), _react2.default.createElement(
	            'ul',
	            { key: 'questions' },
	            data.faqs.edges.map(function (faq, index) {
	                return faq.node.frontmatter.category === category ? _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement(
	                        _Link2.default,
	                        { to: '#' + faq.node.internal.contentDigest },
	                        faq.node.frontmatter.question
	                    )
	                ) : null;
	            })
	        )];
	    });
	
	    var answers = categories.map(function (category, index) {
	        return [_react2.default.createElement(
	            'li',
	            { key: 'category' },
	            category
	        ), _react2.default.createElement(
	            'ul',
	            { key: 'answers' },
	            data.faqs.edges.map(function (faq, index) {
	                return faq.node.frontmatter.category === category ? _react2.default.createElement(
	                    'li',
	                    { key: index },
	                    _react2.default.createElement('a', { className: classes.anchor,
	                        name: faq.node.internal.contentDigest
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        'Q. ',
	                        faq.node.frontmatter.question
	                    ),
	                    _react2.default.createElement('div', {
	                        className: classes.answer,
	                        dangerouslySetInnerHTML: { __html: faq.node.html } })
	                ) : null;
	            })
	        )];
	    });
	
	    return _react2.default.createElement(
	        'div',
	        { className: classes.container },
	        _react2.default.createElement(
	            _BackgroundImageSection2.default,
	            {
	                sizesBackground: data.imageBackground.childImageSharp.sizes },
	            _react2.default.createElement(
	                'h1',
	                null,
	                data.contents.faq.title
	            ),
	            _react2.default.createElement(
	                'p',
	                null,
	                data.contents.faq.description
	            )
	        ),
	        _react2.default.createElement(
	            _Section2.default,
	            {
	                className: classes.sectionIndices,
	                padding: '2rem 0 0.5rem 0' },
	            _react2.default.createElement(
	                'ul',
	                null,
	                _react2.default.createElement(
	                    'li',
	                    null,
	                    'Index'
	                ),
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    indices
	                )
	            )
	        ),
	        _react2.default.createElement(
	            _Section2.default,
	            {
	                className: classes.sectionAnswers,
	                padding: '0 0 16rem 0' },
	            _react2.default.createElement(
	                'ul',
	                null,
	                answers
	            )
	        )
	    );
	});
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-faq-js-b62c7495ca3b74a1aaf9.js